import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import MenuIcon from "@mui/icons-material/Menu";
import Container from "@mui/material/Container";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import PersonIcon from "@mui/icons-material/Person";
import Tooltip from "@mui/material/Tooltip";
import MenuItem from "@mui/material/MenuItem";
import { Link } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import LogoutIcon from "@mui/icons-material/Logout";

import { HOME, INVENTORY, ORDERS, PROFILE, LOGIN } from "../constants/paths";
import {
  HOME_PAGE,
  ORDERS_PAGE,
  INVENTORY_PAGE,
  PROFILE_PAGE,
  LOGOUT_PAGE,
} from "../constants/string";
import { makeStyles } from "@material-ui/core/styles";
import LOGO from "../assets/logo.png";
import WarehouseFilter from "./WarehouseFilter";

const pages = [
  { name: ORDERS_PAGE, path: ORDERS },
  { name: INVENTORY_PAGE, path: INVENTORY },
  { name: PROFILE_PAGE, path: PROFILE },
];

const settings = [{ name: LOGOUT_PAGE, path: LOGIN }];

const useStyles = makeStyles((theme) => ({
  gradientBackground: {
    background: `linear-gradient(to right, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
  },
}));

function ResponsiveAppBar({ isMobile }) {
  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const [anchorElUser, setAnchorElUser] = React.useState(null);
  const authContext = useAuth();

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleCloseUserMenu = (pageName) => {
    if (pageName === LOGOUT_PAGE) {
      authContext.logout();
    }
    setAnchorElUser(null);
  };

  return (
    <AppBar position="static">
      <Toolbar
        disableGutters
      >
        <Box sx={{ display: { xs: "none", md: "flex"}, marginLeft: 1 }}>
          <img
            src={LOGO}
            style={{
              height: 40,
              marginRight: 2,
            }}
          />
        </Box>

        {!isMobile && (
          <Box sx={{ flexGrow: 1, display: { xs: "flex", md: "none" }, marginLeft : 1 }}>
            <IconButton
              size="small"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="inherit"
            >
              <MenuIcon />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{
                display: { xs: "block", md: "none" },
              }}
            >
              {pages.map((page) => (
                <MenuItem
                  key={page.name}
                  onClick={handleCloseNavMenu}
                  component={Link}
                  to={page.path}
                >
                  <Typography textAlign="center">{page.name}</Typography>
                </MenuItem>
              ))}
            </Menu>
          </Box>
        )}

        <Box sx={{ mr: 2, ml: 2,display: { xs: "flex", md: "none" }, flexGrow: 1 }}>
          <img
            src={LOGO}
            style={{
              height: 30,
            }}
          />
        </Box>

        <Box sx={{ flexGrow: 1, display: { xs: "none", md: "flex" } }}>
          {pages.map((page) => (
            <Button
              key={page.name}
              onClick={handleCloseNavMenu}
              sx={{ my: 2, color: "white", display: "block" }}
              component={Link}
              to={page.path}
            >
              <Typography variant="p">{page.name}</Typography>
            </Button>
          ))}
        </Box>

        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-start",
            flexDirection: "row",
            padding: "1vh",
          }}
        >
          <WarehouseFilter />
        </Box>

        <Box sx={{ flexGrow: 0, mr: 1 }}>
          <Tooltip title="Open settings">
            <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
              <Avatar sx={{ bgcolor: "transparent", width: 24, height: 56 }}>
                <LogoutIcon />
              </Avatar>
            </IconButton>
          </Tooltip>
          <Menu
            sx={{ mt: "45px" }}
            id="menu-appbar"
            anchorEl={anchorElUser}
            anchorOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            keepMounted
            transformOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            open={Boolean(anchorElUser)}
            onClose={handleCloseUserMenu}
          >
            {settings.map((setting) => (
              <MenuItem
                key={setting.name}
                onClick={() => handleCloseUserMenu(setting.name)}
                component={Link}
                to={setting.path}
              >
                <Typography textAlign="center">{setting.name}</Typography>
              </MenuItem>
            ))}
          </Menu>
        </Box>
      </Toolbar>
    </AppBar>
  );
}
export default ResponsiveAppBar;
